import Logo from '../../../react/features/AppHeader/components/Logo';
import NavigationList from '../../../react/features/Navigation/List';
import { useAppContext } from '../../../react/hooks/useAppContext';
import Actions from '../../Actions';
import { ListActionsCompact, BottomActionsCompact } from '../../ActionsCompact';
import type { NavStyle, PersistableNavStyle } from '../useNavStyle';
import styles from './style.m.less';

type Props = {
    navStyle: NavStyle;
    setNavStyle: (style: PersistableNavStyle) => void;
};

export default function Sidebar({ navStyle, setNavStyle }: Props) {
    'use memo';
    const { user } = useAppContext();
    const isCompact = navStyle === 'compact';

    return (
        <div
            className={
                {
                    hidden: styles.navigationHidden,
                    compact: styles.navigationCompact,
                    wide: styles.navigationWide,
                }[navStyle]
            }
        >
            <div className={styles.navigationInner} id="mainNavigation">
                <div className={styles.navigationLogo}>
                    <Logo user={user} iconOnly={isCompact} />
                </div>
                <div className={styles.navigationList}>
                    <NavigationList isCompact={isCompact} />
                    {isCompact && <ListActionsCompact />}
                </div>
                {isCompact && <BottomActionsCompact onExpand={() => setNavStyle('wide')} />}
                {!isCompact && <Actions navStyle={navStyle} onCollapse={() => setNavStyle('compact')} />}
            </div>
        </div>
    );
}
